export default {"src":"/_next/static/media/freerunning.c36c08ff.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};